import { Button, Col, Row } from "antd";
import React from "react";
import "./styles.scss";
import PrivacyPolicy from "./privacyPolicy";

const SupportMain = () => {
  return (
    <section className="support-main-container">
      <div className="section-title-text">Find support you need</div>
      <div className="section-title-desc"> #privacy</div>
      <Row gutter={[24, 24]} className="privacy-policy-container">
        {/* <Col xs={0} sm={0} md={24} lg={7} xl={7} xxl={7}>
          <Button type="primary" size="large" block>
            Privacy Policy
          </Button>
        </Col> */}
        <Col span={24}>
          <PrivacyPolicy />
        </Col>
      </Row>
    </section>
  );
};

export default SupportMain;
